// extracted by mini-css-extract-plugin
export default {"works_container":"SectionProjects_works_container__kTO9Z","works_content":"SectionProjects_works_content__tSJ2m","find_out_more":"SectionProjects_find_out_more__h-gKZ"};